import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PasswordDialogComponent } from '../password-dialog/password-dialog.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReportListService } from '../services/report-list/report-list.service';
import { CognitoService } from '../services/cognito/cognito.service';
import { AwsSignerService } from '../services/aws-signer/aws-signer.service';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    PasswordDialogComponent,
    MatProgressSpinnerModule
  ],
  providers: [
    ReportListService,
    CognitoService,
    AwsSignerService
  ]
})
export class ReportListComponent implements OnInit {
  reportList: any[] = [];
  loading: boolean = false;
  loggedIn: boolean = false;
  path: string = '';
  password: string = '';
  currentPath: string = '';
  pathNavigation: any[] = [];
  showTableHeader: boolean = false;
  showBreadcrumb: boolean = false;
  hidePasswordButton: boolean = false;
  signOutSignInLabel: string = 'Login';

  constructor(
    private reportListService: ReportListService,
    public dialog: MatDialog,
    private cognitoService: CognitoService,
  ) { }


  async ngOnInit() {
    if (this.cognitoService.isAuthenticated()) {
      this.signOutSignInLabel = 'Logout';
    }
    console.log('User logged in', this.cognitoService.isAuthenticated());
    return;
  }


  signOutSignIn() {
    if (this.cognitoService.isAuthenticated()) {
      console.log('Sign out');
      this.loggedIn = false;
      this.cognitoService.logout();
      this.loggedIn = false;
      this.signOutSignInLabel = 'Login';
    } else {
      console.log('Sign in');
      this.loggedIn = this.cognitoService.isAuthenticated();
      if (!this.loggedIn) {
        this.cognitoService.authAzure();
      }
    }
  }

  openPasswordDialog(): void {
    console.log('Opening password dialog');
    this.loggedIn = this.cognitoService.isAuthenticated();
    if (!this.loggedIn) {
      console.log('User not authenticated');
      this.signOutSignIn();
    }

    if (this.loading) {
      console.log('Loading in progress');
      return;
    }

    const dialogRef = this.dialog.open(PasswordDialogComponent, {
      data: {
        path: '',
        title: 'Enter Path & Password',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loading = true;
        console.log('The dialog was closed', result);
        if (!result.password || !result.path) {
          this.loading = false;
          alert('Please enter password and path');
          return;
        }
        // this.reportList = [];
        this.fetchReportList(result.password, result.path, result.path);
      }
    });
  }

  fetchReportList(password: string, path: string, currentPath: string): void {
    if (!this.loggedIn) {
      console.log('User not authenticated');
      this.signOutSignIn();
    }

    this.reportListService.getReportList(password, path, currentPath).subscribe(
      (data) => {
        this.showBreadcrumb = true;
        this.hidePasswordButton = true;
        data.forEach((item: any) => {
          if (item.TypeFile) {
            this.showTableHeader = true;
            const fileName = item.FileName.replace('.xlsx', '');
            item.FileName = fileName;
            const date = new Date(item.LastModified);
            const options: Intl.DateTimeFormatOptions = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false,
              timeZone: 'UTC',
            };
            item.LastModified = date.toLocaleString('en-GB', options).replace(',', '');

          } else {
            this.showTableHeader = false;
          }
        });

        this.reportList = data;
        this.loading = false;
        this.currentPath = currentPath;
        this.path = path;
        this.password = password;
        this.generatePathArray(currentPath);
      },
      (error) => {
        console.error('Error fetching file list', error);
        this.loading = false;
        if (error.error.message) {
          alert('Error fetching file list: ' + error.error.message)
        }
      }
    );
  }

  generatePathArray(currentPath: string): void {
    currentPath = currentPath.replace(/^\//, '').replace(/\/$/, '');
    currentPath = '/' + currentPath;
    let pathArray = currentPath.split('/');

    const pathObject = []
    if (currentPath === '/') {
      pathObject.push({
        name: '/',
        path: '/'
      });
    } else {
      for (let i = 0; i < pathArray.length; i++) {
        pathObject.push({
          name: pathArray[i] === '' ? '/' : pathArray[i],
          path: pathArray[i] === '' ? '/' : pathArray.slice(0, i + 1).join('/')
        });
      }
    }

    this.pathNavigation = pathObject;
  }

  goToFolder(currentPath: string): void {
    this.loggedIn = this.cognitoService.isAuthenticated();
    if (!this.loggedIn) {
      console.log('User not authenticated');
      this.signOutSignIn();
    }

    if (this.loading) {
      console.log('Loading in progress');
      return;
    }
    this.loading = true;
    this.fetchReportList(this.password, this.path, currentPath);
  }

  openDownloadPasswordDialog(fileBucket: string): void {
    this.loggedIn = this.cognitoService.isAuthenticated();
    if (!this.loggedIn) {
      console.log('User not authenticated');
      this.signOutSignIn();
    }

    if (this.loading) {
      console.log('Loading in progress');
      return;
    }

    const dialogRef = this.dialog.open(PasswordDialogComponent, {
      data: {
        path: this.path,
        title: 'Enter Password',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loading = true;
        if (!result.password || !result.path) {
          this.loading = false;
          alert('Please enter password and path');
          return;
        }
        this.downloadFile(fileBucket, result.password, result.path);
      }
    });
  }


  downloadFile(fileBucket: string, password: string, path: string): void {
    if (!this.loggedIn) {
      console.log('User not authenticated');
      this.signOutSignIn();
    }
    this.reportListService.getDownloadFileUrl(fileBucket, password, path, this.currentPath).subscribe(
      (data) => {
        // alert('Dolwnload URL: ' + data.downloadUrl + ' Start Downloading');
        const downloadLink = data.downloadUrl;
        const link = document.createElement('a');
        //go to other tab to download
        link.target = '_blank';
        link.href = downloadLink;
        link.download = fileBucket;

        link.click();
        this.loading = false;
      },
      (error) => {
        console.error('Error downloading file', error);
        this.loading = false;
        if (error.error.message) {
          alert('Error fetching file list: ' + error.error.message)
        }
      }
    );
  }


  goToHome(): void {
    this.loading = true;
    window.location.reload();
  }
}
